<template>
  <div>
    <section class="page-content">
      <form action @submit.prevent="next">
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75 mb-0">APPLICATION</h1>
          <h2>Restoration and Remediation Firms Insurance Application</h2>
        </article>
        <article class="input-section form-section" >
          <div style="border: 2px solid black;" class="p-2">
            <h5 class="mt-4 mb-1">
              This application must be signed and dated by an authorized Owner, Partner, Officer, Director or Risk Manager of the first Named Insured.
            </h5>
            <p class="mt-4 mb-1 font-weight-bold">
              <strong>
              Please submit the following information in addition to this application:
              </strong>
            </p>
            <ol>
              <li>
                Five years of currently valued loss runs for those lines of business that coverage is being requested.
              </li>
              <li>
                Two years financials statements including balance sheet and income statement.
              </li>
              <li>
                Certifications / licenses of all key personnel, including IICRC certificates.
              </li>
              <li>
                Resumes of key personnel if you have been in business less than 3 years.
              </li>
              <li>
                Sample of subcontractor agreement used.
              </li>
            </ol>
            <p class="mt-4 mb-1 font-weight-bold" style="font-weight: bold">
              <strong>
                Email Your Supporting Documents to: restoration@orep.org
              </strong>
            </p>
          </div>
        </article>
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">APPLICANT INFORMATION</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            Named Insured(s) (include DBA name, if applicable, and any Additional Named Insureds as written on current or former policy, and for which coverage is being requested):
          </label>
          <input
            type="text"
            name="namedInsured"
            v-model="rcApplication.namedInsured"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('namedInsured')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('namedInsured') | filterText }}</span>
        </article>
        <article class="form-section">
          <div class="input-section" >
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  Street address:
                </label>
                <input
                  type="text"
                  name="address"
                  v-model="rcApplication.customer.address"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('address')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('address') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  City:
                </label>
                <input
                  type="text"
                  name="city"
                  v-model="rcApplication.customer.city"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('city')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('city') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="state"
                  v-model="rcApplication.customer.state"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('state')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('state') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  ZIP Code:
                </label>
                <input
                  type="text"
                  name="zipCode"
                  v-model="rcApplication.customer.zipCode"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('zipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('zipCode') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                  type="text"
                  name="phone"
                  v-model="rcApplication.customer.phone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('phone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('phone') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0 ml-1">
                  Fax:
                </label>
                <input
                  type="text"
                  name="fax"
                  v-model="rcApplication.customer.fax"
                  class="orep-text-input w-100"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('fax')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('fax') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-12">
                <label for class="orep-label mb-0 ml-1">
                  Mailing Address:
                </label>
                <input
                  type="text"
                  name="mailingAddress"
                  v-model="rcApplication.mailingAddress"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingAddress')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingAddress') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Website:
                </label>
                <input
                  type="text"
                  name="fax"
                  v-model="rcApplication.website"
                  class="orep-text-input w-100"
                >
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>FEIN:
                </label>
                <input
                  type="text"
                  name="fein"
                  v-model="rcApplication.fein"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('fein')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('fein') | filterText }}</span>
              </div>

            </div>
            <div class="row pb-3">
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Street Address:
                </label>
                <input
                  type="text"
                  name="streetAddress"
                  v-model="rcApplication.streetAddress"
                  class="orep-text-input w-100"
                  v-validate="'required'"

                >
                <span
                  v-show="errors.has('streetAddress')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('streetAddress') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>City:
                </label>
                <input
                  type="text"
                  name="mailingCity"
                  v-model="rcApplication.mailingCity"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingCity')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingCity') | filterText }}</span>
              </div>
              <div class="col-md-4">
                <label for class="orep-label mb-0 ml-1">
                  State:
                </label>
                <select
                  class="orep-select w-100"
                  style="height: 40px; width: 383px;"
                  name="mailingState"
                  v-model="rcApplication.mailingState"
                  v-validate="'required'"
                  @change="validateBeforeSubmit()"
                >
                  <option v-for="(item, key) in states" :value="key">
                    {{item}}
                  </option>
                </select>
                <span
                  v-show="errors.has('mailingState')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingState') | filterText }}</span>
              </div>


            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Zip Code:
                </label>
                <input
                  type="text"
                  name="mailingZipCode"
                  v-validate="'required'"
                  v-model="rcApplication.mailingZipCode"
                  class="orep-text-input w-100"
                >
                <span
                  v-show="errors.has('mailingZipCode')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingZipCode') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="mr-1"></span>Email:
                </label>
                <input
                  type="email"
                  name="email"
                  autocomplete="email"
                  v-model="rcApplication.customer.email"
                  class="orep-text-input w-100"
                  v-validate="'required|email'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('email')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('email') | filterText }}</span>
              </div>
            </div>
            <div class="row pb-3">
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Contact name:
                </label>
                <input
                  type="text"
                  name="contactName"
                  v-model="rcApplication.contactName"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('contactName')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('contactName') | filterText }}</span>
              </div>
              <div class="col-md-6">
                <label for class="orep-label mb-0">
                  <span class="qtn mrpx-5"></span>Phone:
                </label>
                <input
                  type="text"
                  name="mailingPhone"
                  v-model="rcApplication.mailingPhone"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('mailingPhone')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('mailingPhone') | filterText }}</span>
              </div>
            </div>


          </div>

        </article>
        <article class="input-section form-section">
          <div class="flex">
          <label for class="orep-label">

            Year business started fire/water restoration operations:
            <input
              type="text"
              name="yearBusinessStatedFireWater"
              v-model="rcApplication.yearBusinessStatedFireWater"
              class="orep-text-input w-25"
              v-validate="'required'"
              @input="validateBeforeSubmit()"> years
          </label>
          <span
            v-show="errors.has('yearBusinessStatedFireWater')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('yearBusinessStatedFireWater') | filterText }}</span>
          </div>
          <label for class="orep-label">
            Number of employees:
          </label>
          <input
            type="text"
            name="numberOfEmployees"
            v-model="rcApplication.numberOfEmployees"
            class="orep-text-input w-100"
            v-validate="'required'"
            @input="validateBeforeSubmit()"
          >
          <span
            v-show="errors.has('numberOfEmployees')"
            class="help is-danger form-errors text-danger"
          >{{ errors.first('numberOfEmployees') | filterText }}</span>

        </article>
        <article class="input-section form-section">
          <div class="row">
            <label for class="orep-label col-md-9 col-sm-12">
              Is applicant an industry group member subsidiary, or franchise of another entity?
            </label>
            <div class="col-md-3 d-flex flex-column">
              <div class="d-flex flex-row">
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isApplicantGroupMemberSubsidiary"
                      value="true"
                      class="orep-radio"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.isApplicantGroupMemberSubsidiary"
                    >
                    <span class="radio-span">Yes</span>
                  </label>
                </div>
                <div class="radio orep-radio-wrapper">
                  <label>
                    <input
                      type="radio"
                      name="isApplicantGroupMemberSubsidiary"
                      value="false"
                      class="orep-radio"
                      @change="validateBeforeSubmit()"
                      v-model="rcApplication.isApplicantGroupMemberSubsidiary"
                    >
                    <span class="radio-span">No</span>
                  </label>
                </div>
              </div>
              <span
                v-show="errors.has('isApplicantGroupMemberSubsidiary')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('isApplicantGroupMemberSubsidiary') | filterText }}</span>
            </div>
          </div>
          <div class="flex"  v-if="rcApplication.isApplicantGroupMemberSubsidiary == true || rcApplication.isApplicantGroupMemberSubsidiary === 'true'">
            <label for class="orep-label">
              If yes, what entity?
            </label>
            <input
              type="text"
              name="dateFirmEstablished"
              v-model="rcApplication.dateFirmEstablished"
              class="orep-text-input"
              v-validate="'required'"
              @input="validateBeforeSubmit()"
            >
          </div>
        </article>

        <article class="input-section form-section">
          <div class="row align-items-center mx-1 pb-0 pt-3">
            <label for class="orep-label mb-0">Applicant operates as an:</label>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="individual"
                  class="orep-radio"
                  v-validate="'required|included:individual,corporation,partnership,jointVenture,llc,other'"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">Individual</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="corporation"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">Corporation</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="partnership"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">Partnership</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="jointVenture"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">Joint Venture</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="llc"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">LLC</span>
              </label>
            </div>
            <div class="radio orep-radio-wrapper w-100">
              <label>
                <input
                  type="radio"
                  name="applicantOwnership"
                  value="other"
                  class="orep-radio"
                  @change="validateBeforeSubmit()"
                  v-model="rcApplication.applicantOwnership"
                >
                <span class="radio-span">Other</span>
              </label>
            </div>
            <span
              v-show="errors.has('applicantOwnership')"
              class="help is-danger form-errors text-danger mt-0 mb-2"
            >{{ errors.first('applicantOwnership') | filterText }}</span>
          </div>
        </article>
        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">COVERAGE REQUESTED</h1>
        </article>
        <article class="input-section form-section">
          <label for class="orep-label">
            <span class="qtn mrpx-5"></span>Check the box that applies:
          </label>
          <div class="row">
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.environmentalCombinedPolicy"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Environmental Combined Policy (GL, CPL & ECL)</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiability"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Contractors Pollution Liability (CPL) only</span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.environmentalConsultantsLiability"
                  >
                  <span
                    class="radio-span solo-checkbox-span no-top"
                  >Environmental Consultants Liability (ECL) only</span>
                </label>
              </div>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    name="coverages"
                    value
                    class="orep-radio position-relative"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsConsultantsPolicy"
                  >
                  <span class="radio-span solo-checkbox-span no-top">Contractors & Consultants Policy (CPL & ECL) combined</span>
                </label>
              </div>
              <!--                  <div class="radio orep-radio-wrapper solo-checkbox">-->
              <!--                    <label class="d-flex align-items-center">-->
              <!--                      <input-->
              <!--                        type="checkbox"-->
              <!--                        name="deductible"-->
              <!--                        value-->
              <!--                        class="orep-radio position-relative"-->
              <!--                        v-model="rcApplication.cyberProtection"-->
              <!--                      >-->
              <!--                      <span-->
              <!--                        class="radio-span solo-checkbox-span no-top"-->
              <!--                      >Cyber Protection: I would like information on Cyber Coverage ($89 for $100,000 limits; $59 for $50,000 limits)</span>-->
              <!--                    </label>-->
              <!--                  </div>-->
            </div>

          </div>
        </article>

        <article class="input-section form-section">
        <div style="margin-top: 30px;">
          <label for class="orep-label">
            Limits of Insurance Requested:
          </label>
          <div class="row">
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                Each Occurrence/Claim
                 $:
              </label>
              <input
                type="text"
                name="OccurrenceOrClaim"
                v-model="rcApplication.OccurrenceOrClaim"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('OccurrenceOrClaim')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('OccurrenceOrClaim') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                Aggregate $:
              </label>
              <input
                type="text"
                name="aggregate"
                v-model="rcApplication.aggregate"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('aggregate')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('aggregate') | filterText }}</span>
            </div>
            <div class="col-md-4">
              <label for class="orep-label mb-0">
                Deductible/SIR $:
              </label>
              <input
                type="text"
                name="deductible"
                v-model="rcApplication.deductible"
                class="orep-text-input w-100"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              >
              <span
                v-show="errors.has('deductible')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('deductible') | filterText }}</span>
            </div>
          </div>
        </div>
          <div style="margin-top: 30px;">
          <div class="row">
            <div class="col-md-6">
              <label for class="orep-label mb-0 ml-1">
                Proposed Effective date:
              </label>
              <datepicker
                name="effectiveDate"
                v-model="rcApplication.effectiveDate"
                v-validate="'required'"
                format="MM/dd/yyyy"
                input-class="orep-text-input"
                @input="validateBeforeSubmit()"
                :disabled="state.effectiveDateValid"
                :clearButton="false"
                :value="computedDates"
              ></datepicker>
              <span
                v-show="errors.has('effectiveDate')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('effectiveDate') | filterText }}</span>
            </div>
            <div class="col-md-6">
              <label for class="orep-label mb-0 ml-1">
                Proposed Expiration date:
              </label>
              <datepicker
                name="expirationDate"
                v-model="rcApplication.expirationDate"
                format="MM/dd/yyyy"
                input-class="orep-text-input"
                :disabled="state.expirationDateValid"
                :clearButton="false"
                :value="computedDates"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
              ></datepicker>
              <span
                v-show="errors.has('expirationDate')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('expirationDate') | filterText }}</span>
            </div>
          </div>
          </div>
        </article>


        <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
          <h1 class="font-weight-bold text-center w-75">EXPIRING INSURANCE PROGRAM</h1>
        </article>

        <article class="input-section form-section">
          <div class="table-scroll">
            <table width="100%">
              <thead>
              <tr>
                <th colspan="2">General Liability</th>
                <th colspan="2">Contractors Pollution Liability</th>
                <th colspan="2">Professional Liability</th>
              </tr>
              <tr>
                <th colspan="2">None
                  <input
                    type="checkbox"
                    name="generalLiabilityNone"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.generalLiabilityNone"
                  >
                </th>
                <th colspan="2">None
                  <input
                    type="checkbox"
                    name="contractorsPollutionLiabilityNone"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.contractorsPollutionLiabilityNone"
                  >
                </th>
                <th colspan="2">None
                  <input
                    type="checkbox"
                    name="professionalLiabilityNone"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.professionalLiabilityNone"
                  >
                </th>
              </tr>
              <tr>
                <th>Occurrence
                  <input
                    type="checkbox"
                    name="generalLiabilityOccurrence"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.generalLiabilityOccurrence"
                  >
                </th>
                <th>Claims Made
                  <input
                    type="checkbox"
                    name="generalLiabilityClaimsMade"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.generalLiabilityClaimsMade"
                  >
                </th>
                <th>Occurrence
                  <input
                    type="checkbox"
                    name="contractorsPollutionLiabilityOccurrence"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.contractorsPollutionLiabilityOccurrence"
                  >
                </th>
                <th>Claims Made
                  <input
                    type="checkbox"
                    name="contractorsPollutionLiabilityClaimsMade"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.contractorsPollutionLiabilityClaimsMade"
                  >
                </th>
                <th>Occurrence
                  <input
                    type="checkbox"
                    name="professionalLiabilityOccurrence"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.professionalLiabilityOccurrence"
                  >
                </th>
                <th>Claims Made
                  <input
                    type="checkbox"
                    name="professionalLiabilityClaimsMade"
                    value
                    class="orep-radio position-relative"
                    v-model="rcApplication.professionalLiabilityClaimsMade"
                  >
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  Carrier:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityCarrier"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityCarrier"
                  >
                </td>
                <td>
                  Carrier:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityCarrier"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityCarrier"
                  >
                </td>
                <td>
                  Carrier:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityCarrier"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityCarrier"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Limits:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityLimits"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityLimits"
                  >
                </td>
                <td>
                  Limits:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityLimits"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityLimits"
                  >
                </td>
                <td>
                  Limits:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityLimits"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityLimits"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Deductible / SIR:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityDeductible"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityDeductible"
                  >
                </td>
                <td>
                  Deductible / SIR:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityDeductible"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityDeductible"
                  >
                </td>
                <td>
                  Deductible / SIR:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityDeductible"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityDeductible"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Premium:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityPremium"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityPremium"
                  >
                </td>
                <td>
                  Premium:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityPremium"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityPremium"
                  >
                </td>
                <td>
                  Premium:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityPremium"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityPremium"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Effective Dates:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityEffectiveDates"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityEffectiveDates"
                  >
                </td>
                <td>
                  Effective Dates:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityEffectiveDates"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityEffectiveDates"
                  >
                </td>
                <td>
                  Effective Dates:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityEffectiveDates"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityEffectiveDates"
                  >
                </td>
              </tr>
              <tr>
                <td>
                  Retroactive Date:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="generalLiabilityetroactiveDate"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.generalLiabilityetroactiveDate"
                  >
                </td>
                <td>
                  Retroactive Date:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="contractorsPollutionLiabilityetroactiveDate"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.contractorsPollutionLiabilityetroactiveDate"
                  >
                </td>
                <td>
                  Retroactive Date:
                </td>
                <td>
                  <input
                    type="text"
                    class="orep-text-input"
                    name="professionalLiabilityetroactiveDate"
                    @input="validateBeforeSubmit()"
                    v-model="rcApplication.professionalLiabilityetroactiveDate"
                  >
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          
        </article>




      </form>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('rc-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('rc-application-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {APP_STATUS, STATES} from "../../utils/constants";
import Datepicker from 'vuejs-datepicker';
import moment from "moment";



export default {
  name: "rc-application-1",
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/rc-application-amba/' || this.rcApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/rc-application-realshield/' || this.rcApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },

  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },

  methods: {
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.rcApplication.customer.contactName = this.state.rcApplication.namedInsured;
      this.rcApplication.customer.companyName = this.state.rcApplication.contactName;
      this.rcApplication.customer.isRcApplication = 'True';
      this.rcApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.rcApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield'){
        this.rcApplication.customer.partnerName = 'Realshield';
      }
      this.$store.dispatch('rcApplication/createCustomer');

      // this.$router.push({
      //   name: routeName,
      // });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.rcApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td, table th{
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>
